<template>
  <aside v-click-outside="handleClickOutside" class="menu" :class="{ 'menu--open': isOpenMenu }">
    <div class="menu__header">
      <button class="menu__trigger" @click="$emit('trigger-menu')">
        <svg-icon name="menu" />
      </button>
      <router-link to="/">
        <transition name="fade" :duration="200">
          <svg-icon v-if="isOpenMenu" name="logo-full" class="menu__logo" />
          <svg-icon v-else name="logo-mobile" class="menu__logo" />
        </transition>
      </router-link>
    </div>
    <button class="menu__trigger menu__trigger--desktop" @click="$emit('trigger-menu')">
      <svg-icon name="menu" />
    </button>
    <UserMenu :is-open-menu="isOpenMenu" :user="user" @login="$emit('open-modal-login')" />
    <MenuItems :is-open-menu="isOpenMenu" @trial-lesson="$emit('open-modal-trial')" />
  </aside>
</template>

<script>
import UserMenu from '@/components/Layout/UserMenu'
import MenuItems from '@/components/Layout/MenuItems'

export default {
  name: 'Menu',
  components: { MenuItems, UserMenu },
  data: () => ({
    user: {
      id: 1,
      avatar: ''
    }
  }),

  props: {
    isOpenMenu: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isOpenMenu(value) {
      document.documentElement.style.overflow = value ? 'hidden' : 'visible'
    }
  },

  methods: {
    handleClickOutside(e) {
      if (e.target.classList.contains('header__trigger') || e.target.closest('.header__trigger')) {
        return
      }

      this.$emit('update:isOpenMenu', false)
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  width: 120px;
  box-shadow: 0 4px 20px rgba($mine-shaft, 0.05);
  padding: 24px 32px;
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  align-items: flex-start;
  background: $white;
  z-index: 20;

  @include md-and-down {
    width: 0;
    opacity: 0;
    visibility: hidden;
  }

  &__logo {
    height: 48px;

    @include md-and-down {
      height: 24px;
    }
  }

  &--open {
    width: 240px;
    padding: 24px 12px 24px 32px;

    @include md-and-down {
      opacity: 1;
      visibility: visible;
      padding: 52px 32px 52px 16px;
    }
  }

  &--open &__trigger {
    margin-left: 8px;
    padding-left: 0;
  }

  &__header {
    display: flex;
    align-items: center;

    @include md-and-down {
      margin-bottom: 40px;
    }
  }

  &__trigger {
    margin: 40px 0 24px;
    display: none;
    padding-left: 12px;

    @include md-and-up {
      &--desktop {
        display: block;
      }
    }

    svg {
      width: 32px;
      height: 32px;
      fill: $luchmara;
    }

    @include md-and-down {
      &:not(&--desktop) {
        display: block;
        margin: 0 16px 0 0;

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }

    &:hover {
      transform: translateY(-1px);

      svg {
        fill: rgba($luchmara, 0.8);
      }
    }
  }
}
</style>
